import { DotsHorizontalIcon } from "@enkor/design/icons";
import BaseUserProfileViewModel from "@domains/common/viewModel/BaseUserProfileViewModel";

import * as S from "./AvatarList.style";

interface AvatarListProps {
  spaceBetween?: boolean;
  withBorder?: boolean;
  avatarList?: BaseUserProfileViewModel[];
  additionalText?: string;
  avatarDisplayLimit?: number;
}

export const AVATAR_DISPLAY_LIMIT = {
  CARD: 3,
  EVENT: 15,
};

const AvatarList = ({
  spaceBetween = false,
  withBorder = false,
  avatarList = [],
  additionalText,
  avatarDisplayLimit = AVATAR_DISPLAY_LIMIT.CARD,
}: AvatarListProps) => {
  const hasAvatarList = avatarList?.length !== 0;
  const isShowDotsAvatar = avatarList?.length >= avatarDisplayLimit;

  return (
    <S.Container $spaceBetween={spaceBetween} $hasList={hasAvatarList}>
      <S.Avatars>
        {avatarList.slice(0, avatarDisplayLimit).map((avatar, index) => (
          <S.AvatarWrapper
            key={`User-${avatar?.userId || index}`}
            $withBorder={withBorder}
          >
            <S.Avatar
              fill
              sizes="18"
              src={avatar.profileImage || "/assets/image_default9.png"}
              alt={`User-${index}`}
            />
          </S.AvatarWrapper>
        ))}
        {isShowDotsAvatar && (
          <S.DotsAvatarWrapper $withBorder={withBorder}>
            <DotsHorizontalIcon size={12} />
          </S.DotsAvatarWrapper>
        )}
      </S.Avatars>
      {additionalText && (
        <S.AdditionalText name="s">{additionalText}</S.AdditionalText>
      )}
    </S.Container>
  );
};

export default AvatarList;
